export default "__VITE_ASSET__DFVJKRuU__"